<template>
  <div class="template-one-column">
    <div
      class="template-one-column__container"
      :style="singleArticleContainerStyle"
    >
      <!-- Контент должен находиться выше других элементов. Важно для seo. (LH-1368)-->
      <div class="single-article__wrapper">
        <div class="single-article">
          <section class="single-article__content">
            <AdminControlsPanel
              v-if="isAuthenticatedInWordpress"
              class="admin-controls"
              :views-count="viewsCount"
              :edit-link-href="editLinkHref"
              :loading="getLoadingViews(article.id)"
              @click-on-restore-button="updateViewsCount(article.id)"
            />
            <ArticleCard
              class="single-article-card"
              :article="article"
              :title="articleTitle"
              :comments-count="commentsCount"
              :user="user"
              :favorite="favorites"
              :folders="folders"
              :to-comments-link="false"
              :comments-enabled="article.commentsEnabled"
              @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
              @favorite-create-folder-and-add="
                (nameFolder) => onFavoriteCreateFolderAndAdd(nameFolder, article)
              "
              @favorite-create-folder-and-transfer="
                (nameFolder, favorite) =>
                  onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article)
              "
              @favorite-transfer-to-folder="
                (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
              "
              @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
              @favorite-deferred="onFavoriteDeferred"
              @clicked-on-category="onClickOnCategory"
            />

            <!-- id article указан в JSON+LD -->
            <article
              id="article"
              class="single-article__post-content single-article__content-container"
              @click="checkImageClick"
            >
              <template v-for="(content, idx) in slicedContents">
                <!-- контент статьи-->
                <TheContent
                  v-for="item of content"
                  :key="item.id"
                  :elem="item"
                  :lazy-loading-enabled="true"
                />

                <!-- виджеты внутри контента-->
                <WidgetsRendererContainer
                  v-if="
                    isWidgetsRendererVisible && typeof widgetsInsideContent[idx] !== 'undefined'
                  "
                  :widgets="widgetsInsideContent[idx]"
                />
              </template>
            </article>

            <!-- текст под контентом статьи. Обложка, источник и тп-->
            <ArticleNote
              class="article-note"
              :class="{ 'article-note_empty': !articleNotes.length }"
              :notes="articleNotes"
            />

            <!-- ArticleCardActions-->
            <component
              :is="articleCardComponent"
              in-page-position="bottom"
              event-position="bottom"
              class="article__actions"
              :article-id="article.id"
              :url="article.teaserUrl || article.url"
              :cover-url="
                article.img && article.img[0] && article.img[0].url ? article.img[0].url : null
              "
              :comments-enabled="article.commentsEnabled && !article.teaserUrl"
              :comments-count="commentsCount"
              :title="articleTitle"
              :user="user"
              :favorite="favorites"
              :folders="folders"
              :can-have-reactions="article.canHaveReactions"
              @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
              @favorite-create-folder-and-add="
                (nameFolder) => onFavoriteCreateFolderAndAdd(nameFolder, article)
              "
              @favorite-create-folder-and-transfer="
                (nameFolder, favorite) =>
                  onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article)
              "
              @favorite-transfer-to-folder="
                (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
              "
              @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
              @favorite-deferred="onFavoriteDeferred"
            />
          </section>

          <!-- зона виджетов "над комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="widgets above-comments-widgets__container"
            :widgets="aboveCommentsWidgets"
          />

          <!-- комментарии-->
          <CommentsContainer
            v-if="showComments"
            :id="article.id"
            class="comments"
          />

          <!-- зона виджетов "под комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="below-comments-widgets__container"
            :widgets="belowCommentsWidgets"
          />
        </div>
      </div>

      <!-- Полноэкранная галерея-->
      <FullScreenGallery
        v-if="isGalleryVisible"
        :image-urls="imagesSrc"
        :srcset="imagesSrcset"
        :current-slide="currentImageId"
        @close="closeGallery"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import GeneralTemplates from './general';

  // Берем за основу компонент generalTemplate, но даем ему уникальное имя
  // Без уникального имени может рендериться не корректный шаблон
  export default defineNuxtComponent({
    ...GeneralTemplates,
    name: 'OneColumn',
  });
</script>

<style lang="scss" scoped>
  $borderColor: #e7e7e7;

  $border: 1px solid #e7e7e7;

  .template-one-column {
    &__container {
      background: #fff;
      @include desktop {
        background: unset;
      }
    }

    &.jumper-post {
      .single-article__content {
        margin-bottom: 0px;

        @include tablet {
          margin-bottom: 24px;
        }
      }

      .single-article__wrapper {
        margin-bottom: 48px;
      }
    }

    .single-article {
      max-width: 640px;
      margin: 0 auto;
      padding-bottom: 1px;
      background: var(--bg-color-substrate);

      @include tablet {
        background: white;
      }

      @include big-tablet {
        max-width: 780px;
      }

      &__content {
        border-bottom: $border;
        background: white;
        margin-bottom: 24px;

        @include tablet {
          border-bottom: none;
        }
      }

      &__post-content {
        :deep(.lightgrey-box) {
          margin: 0;
        }
      }

      &__wrapper {
        @include tablet {
          background: white;
        }

        @include big-tablet {
          max-width: 1024px;
          margin-left: auto;
          margin-right: auto;
        }

        @include desktop {
          border: 1px solid $borderColor;
          max-width: 1280px;
        }
      }
    }

    .single-article-card {
      border: none;
      @include big-tablet {
        max-width: 780px;
      }
    }

    .admin-controls {
      margin-left: 16px;
      padding-top: 16px;

      @include tablet {
        margin-left: 24px;
      }
    }

    .admin-controls + .single-article-card {
      padding-top: 12px;

      @include tablet {
        padding-top: 0px;
      }
    }

    .single-article__page-content-wrapper {
      background: white;
      padding: 16px 0 32px;
      max-width: 1280px;
      margin: 0 auto;

      @include tablet {
        padding: 24px 0 40px;
        border: 1px solid #e7e7e7;
      }

      @include desktop {
        padding: 24px 24px 40px;
      }
    }

    .single-article__page-content {
      // https://app.clickup.com/t/2wma072
      // max-width: 640px;
      max-width: 780px;
      margin: 0 auto;
    }

    :deep(.article-card__cover) {
      @include tablet {
        max-width: 592px;
      }
      @include big-tablet {
        max-width: 732px;
      }
    }

    :deep(.article-card-actions) {
      @include tablet {
        margin-left: 24px;
        margin-right: 24px;
      }
    }

    :deep(.age-calculator) {
      @include tablet {
        margin: 0 0 12px;
      }
    }

    :deep(.ovulation-calculator) {
      @include tablet {
        margin: 0 0 12px;
      }
    }

    :deep(.article-card__above-cover),
    :deep(.article-note) {
      @include tablet {
        padding: 0 24px;
      }
    }
  }
</style>
